module.exports = __webpack_public_path__ + "static/media/Foot Ball Studio.35ba0f13.jpg";